import cn from 'classnames';
import CouponTabsPill from 'features/coupon/component/CouponTabsPill';
import { motion, useAnimation, Variants } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AKO, BONUS_BALANCE, SYSTEM } from 'shared/constants/common';
import { BalanceState, BETSType, State } from 'shared/interface/index';
import './styles.scss';

interface CouponTabsProps {
	bets: BETSType;
	balanceData: BalanceState;
	onChangeGameMode: (arg: string) => void;
	isBetslipEmpty: boolean;
}
const CouponTabs = ({ onChangeGameMode, balanceData, bets, isBetslipEmpty }: CouponTabsProps) => {
	const { t } = useTranslation();
	const isFreeBetSelected = useSelector<State, any>((state) => state.coupon.bets.isFreeBetSelected);
	const isAkoBet = bets.outcomes.filter((item) => item.selectedBet).length > 1;

	const numOfSlipsInBetslip = bets.outcomes.length + bets.blocks.flat().length;
	const isBetmodeSystem = bets.betMode === SYSTEM;
	const isBonusBalanceSelected = balanceData.selectedBalanceType === BONUS_BALANCE;
	const hasMultipleSlips = numOfSlipsInBetslip > 1;

	const handleTabChangeToSystem = () => {
		onChangeGameMode(SYSTEM);
	};

	const handleTabChangeToAko = () => {
		if (bets.betMode !== AKO) {
			onChangeGameMode(AKO);
		}
	};

	useEffect(() => {
		controls.start(hasMultipleSlips ? 'visible' : 'hidden');
		if (bets.betMode === SYSTEM && numOfSlipsInBetslip === 1) {
			onChangeGameMode(AKO);
		}
		if (isBetmodeSystem && (isBonusBalanceSelected || isFreeBetSelected)) {
			handleTabChangeToAko();
		}
	}, [isAkoBet, isBetmodeSystem, isBonusBalanceSelected, isFreeBetSelected, isBetslipEmpty]);

	const controls = useAnimation();
	const variants: Variants = {
		visible: { x: 0, opacity: 1 },
		hidden: { x: '-100%', opacity: 0, zIndex: 0 },
	};

	return (
		<div className={cn('couponTabs', { 'couponTabs--noBets': isBetslipEmpty }, { 'couponTabs--withBets': !isBetslipEmpty })}>
			{!isBetslipEmpty && (
				<>
					<div className="couponTabs__buttons">
						<CouponTabsPill
							text={hasMultipleSlips ? t('akoBetType') : t('soloBetType')}
							onClick={handleTabChangeToAko}
							isActive={bets.betMode === AKO}
							cyTestRef="betslip-pills"
						/>
						<motion.div initial={isBetmodeSystem ? 'visible' : 'hidden'} variants={variants} animate={controls}>
							<CouponTabsPill
								disabled={isBonusBalanceSelected || isFreeBetSelected}
								text={t('systemBetType')}
								onClick={handleTabChangeToSystem}
								isActive={bets.betMode === SYSTEM}
								cyTestRef="betslip-pills"
							/>
						</motion.div>
					</div>
				</>
			)}
		</div>
	);
};

export default CouponTabs;
